import PurchasesPage from './PurchasesPage'

export default PurchasesPage
